import AcademyInfoFooter from './AcademyInfoFooter';
import AchievementDescription from './AchievementDescription';
import CertificateImage from './CertificateImage';
import CurriculumInfo from './CurriculumInfo';
import FooterCTA from './FooterCTA';
import ColorCirclesHeader from '../../../components/ColorCirclesHeader';
import AchievementNotFound from './AchievementNotFound';
import AchievementUserProfile from './AchievementUserProfile';
import CertificateHeader from './CertificateHeader';
import { getBrochureRoot, usePublicAchievement, useAchievementTrackId, useAchievementLessons } from '../achievementQueries';
import { addUrlParams } from 'LearningCenterUI/utils/RoutingUtils';
import { NavMarker } from 'react-rhumb';
import { useEffect } from 'react';
import PrerenderGlobals from './PrerenderGlobals';
import { View } from 'foundations-components/components/View';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Flex } from 'foundations-components/components/Flex';
import { ConditionalThemeProvider } from 'academy-common-lib/features/publicTheme/ConditionalThemeProvider';
import { getMarketingThemePreference } from 'academy-common-lib/features/publicTheme/themeUtils';
import { useMediaQuery } from 'academy-common-lib/utils/Styling';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedMessage from 'I18n/components/FormattedMessage';
import I18n from 'I18n';
import { getFullUrl } from 'hubspot-url-utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Container = ({
  children
}) => {
  return /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    marginInline: "auto",
    maxInlineSize: "1140px",
    paddingInline: "500",
    children: children
  });
};
const MarketingBackground = ({
  children
}) => {
  const {
    isTablet
  } = useMediaQuery();
  return /*#__PURE__*/_jsx(View, {
    backgroundColor: "fill-surface-recessed",
    paddingBlockEnd: isTablet ? '1400' : '1500',
    paddingBlockStart: isTablet ? '1000' : '1400',
    children: children
  });
};
export const SingleAchievement = ({
  inModal,
  trackEvent,
  publicId,
  language
}) => {
  var _publicAchievementUse;
  const isMarketingThemeEnabled = getMarketingThemePreference();
  const {
    isLaptop
  } = useMediaQuery();
  const Header = isMarketingThemeEnabled ? MarketingBackground : ColorCirclesHeader;
  const {
    publicAchievementLoading,
    publicAchievementError,
    publicAchievementErrorMessage,
    publicAchievement,
    publicAchievementUser
  } = usePublicAchievement(publicId);
  const lessons = useAchievementLessons(publicId);
  const trackId = useAchievementTrackId(publicId);
  const hasTrack = !!trackId;
  const brochureRoot = getBrochureRoot(language);
  const appBaseUrl = getFullUrl('app');
  const courseLink = hasTrack ? addUrlParams(`${appBaseUrl}/academy/tracks/${trackId}`, {
    'hubs_content-cta': 'achievement-cta-cert-image'
  }) : undefined;
  const userId = publicAchievement === null || publicAchievement === void 0 ? void 0 : publicAchievement.userId;
  const profileLink = addUrlParams(`${appBaseUrl}/l/academy/profile/${userId !== null && userId !== void 0 ? userId : ''}`, {
    'hubs_content-cta': 'achievement-cta-view-profile'
  });
  const firstName = (_publicAchievementUse = publicAchievementUser === null || publicAchievementUser === void 0 ? void 0 : publicAchievementUser.firstName) !== null && _publicAchievementUse !== void 0 ? _publicAchievementUse : '';
  const achievementTitle = (publicAchievement === null || publicAchievement === void 0 ? void 0 : publicAchievement.credentialDefinitionName) || I18n.text('learningCenter.certification.achievementTitle');
  const achievementDescription = (publicAchievement === null || publicAchievement === void 0 ? void 0 : publicAchievement.credentialDefinitionDescription) || I18n.text('learningCenter.certification.achievementDescription', {
    firstName
  });
  useEffect(() => trackEvent({
    action: 'view-achievement'
  }), [trackEvent]);
  if (publicAchievementLoading) {
    return /*#__PURE__*/_jsx(LoadingSpinner, {
      grow: true,
      marginBlock: "1200"
    });
  }
  if (publicAchievementError || publicAchievementErrorMessage) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "ACHIEVEMENT_MISSING",
      children: /*#__PURE__*/_jsx(AchievementNotFound, {
        brochureRoot: brochureRoot
      })
    });
  }
  const CURRICULUM_DISPLAY_THRESHOLD = 6;
  const showStackedCurriculum = hasTrack && lessons && lessons.length > CURRICULUM_DISPLAY_THRESHOLD;
  const isColumnLayout = isLaptop || showStackedCurriculum;
  return /*#__PURE__*/_jsx(ConditionalThemeProvider, {
    children: /*#__PURE__*/_jsxs("div", {
      "data-test-id": "achievement-public",
      children: [/*#__PURE__*/_jsx(PrerenderGlobals, {
        publicId: publicId
      }), /*#__PURE__*/_jsxs(NavMarker, {
        name: "ACHIEVEMENT_LOADED",
        children: [/*#__PURE__*/_jsx(View, {
          backgroundColor: "fill-surface-default",
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(CertificateHeader, {
              inModal: inModal,
              language: language,
              trackEvent: trackEvent
            })
          })
        }), /*#__PURE__*/_jsx(Header, {
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsx(AchievementUserProfile, {
              publicId: publicId
            })
          })
        }), /*#__PURE__*/_jsx(Flex, {
          backgroundColor: "fill-surface-default",
          justifyContent: isColumnLayout ? 'center' : 'start',
          marginBlockEnd: isMarketingThemeEnabled || !isLaptop ? '0' : '1200',
          children: /*#__PURE__*/_jsx(Container, {
            children: /*#__PURE__*/_jsxs(Flex, {
              alignItems: isColumnLayout && hasTrack ? 'center' : undefined,
              flexDirection: isColumnLayout ? 'column' : 'row',
              flexWrap: "wrap",
              children: [/*#__PURE__*/_jsx(View, {
                flex: "1",
                maxInlineSize: isLaptop ? undefined : '528px',
                minInlineSize: "300px",
                children: /*#__PURE__*/_jsx(CertificateImage, {
                  inModal: inModal,
                  publicId: publicId
                })
              }), /*#__PURE__*/_jsxs(View, {
                flex: "1",
                inlineSize: isLaptop ? '100%' : undefined,
                minInlineSize: "300px",
                children: [hasTrack && lessons ? /*#__PURE__*/_jsx(CurriculumInfo, {
                  lessons: lessons,
                  showStackedView: showStackedCurriculum || false
                }) : /*#__PURE__*/_jsx(AchievementDescription, {
                  centered: false,
                  description: achievementDescription,
                  hasMargin: !isColumnLayout,
                  title: achievementTitle
                }), publicAchievement && /*#__PURE__*/_jsx(View, {
                  marginInlineStart: showStackedCurriculum || isLaptop ? '0' : '1200',
                  paddingBlockStart: hasTrack && lessons ? '600' : '1000',
                  textAlign: showStackedCurriculum ? 'center' : 'left',
                  children: hasTrack ? /*#__PURE__*/_jsx(Button, {
                    "aria-label": I18n.text('learningCenter.certification.viewCourse'),
                    "data-test-id": "achievement-view-course-button",
                    href: courseLink,
                    onClick: () => trackEvent({
                      action: 'click-primary-cert',
                      href: courseLink,
                      isExternalLink: false
                    }),
                    use: "primary",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "learningCenter.certification.viewCourse"
                    })
                  }) : /*#__PURE__*/_jsx(Button, {
                    "aria-label": I18n.text('learningCenter.certification.viewTheirProfile'),
                    "data-test-id": "achievement-view-profile-button",
                    href: profileLink,
                    onClick: () => trackEvent({
                      action: 'click-view-profile',
                      href: profileLink,
                      isExternalLink: false
                    }),
                    use: "primary",
                    children: /*#__PURE__*/_jsx(FormattedMessage, {
                      message: "learningCenter.certification.viewTheirProfile"
                    })
                  })
                })]
              })]
            })
          })
        }), /*#__PURE__*/_jsxs(View, {
          backgroundColor: isMarketingThemeEnabled ? undefined : 'fill-accent-neutral-default',
          children: [/*#__PURE__*/_jsx(AcademyInfoFooter, {
            inModal: inModal
          }), !inModal && /*#__PURE__*/_jsx(FooterCTA, {
            language: language,
            publicId: publicId,
            trackEvent: trackEvent
          })]
        })]
      })]
    })
  });
};